/**
 * Canale evento tipizzato per propagare il salvataggio della configurazione di
 * un agente Personal Assistant tra sottoalberi React separati (il modale di
 * configurazione in `AITools` vive in un albero diverso da `PersonalAssistantChat`
 * e dall'icona/nome in `Header`). Emesso al salvataggio riuscito, consente alle
 * superfici interessate di rileggere lo stato senza ricaricare la pagina.
 */
export const PERSONAL_ASSISTANT_UPDATED_EVENT = 'personal-assistant:updated' as const;

export interface PersonalAssistantUpdatedDetail {
  /**
   * Id dell'agente salvato. `null` quando non determinabile (es. risposta
   * upstream priva di id): in tal caso i listener rileggono comunque, senza
   * filtrare per id.
   */
  assistantId: string | null;
}

export interface PersonalAssistantSectionRequest {
  id: number;
  section: 'routines';
}

/** Notifica chat + header che la configurazione di un agente PA è cambiata. */
export function emitPersonalAssistantUpdated(detail: PersonalAssistantUpdatedDetail): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<PersonalAssistantUpdatedDetail>(PERSONAL_ASSISTANT_UPDATED_EVENT, { detail }),
  );
}

declare global {
  interface WindowEventMap {
    'personal-assistant:updated': CustomEvent<PersonalAssistantUpdatedDetail>;
  }
}
